'use strict';

function FareBasisGroupsGridDirective() {
  return {
    restrict: 'E',
    controller: 'FareBasisGroupsGridController',
    template: require('../templates/fare-basis-groups.html'),
    scope: {}
  };
}
FareBasisGroupsGridDirective.$inject = [];
module.exports = FareBasisGroupsGridDirective;